/**
 * Audio constants
 */

import { assetUrl } from '../../utils/pathResolver'
import storyData from '../../config/story.json'

export const AUDIO_BASE_PATH = assetUrl('/assets/audio')

export const AUDIO_CONFIG = {
  volume: 0.7,
  fadeOutDuration: 200, // milliseconds
  fadeInDuration: 100, // milliseconds
} as const

type StorySettings = typeof storyData.config.settings

/**
 * Maximum volume per category (0-1). User sliders operate as 0-100% of these ceilings.
 * Initialized from story.json config.settings.volumeCeilings, editable at runtime via debug modal.
 */
export const VOLUME_CEILINGS = {
  speech: (storyData.config.settings?.volumeCeilings?.speech ?? 100) / 100,
  atmo: (storyData.config.settings?.volumeCeilings?.atmo ?? 90) / 100,
  sound: (storyData.config.settings?.volumeCeilings?.sound ?? 90) / 100,
  music: (storyData.config.settings?.volumeCeilings?.music ?? 70) / 100,
}

export function getVolumeCeilings() {
  return VOLUME_CEILINGS
}

export function getSettingsDefaults(): { music: number; speech: number; sound: number; animationsEnabled: boolean } {
  const d = (storyData.config as { settings?: StorySettings }).settings?.defaults
  return {
    music: d?.music ?? 70,
    speech: d?.speech ?? 100,
    sound: d?.sound ?? 70,
    animationsEnabled: d?.animationsEnabled ?? true,
  }
}
